import React from "react";
import {Typography, Link} from "@material-ui/core";
import {Link as ReactLink} from "react-router-dom";

import AppColors from './../colors/AppColors';
import Strings from './../lang/Strings';
import {grey, red} from "@material-ui/core/colors";
import FooterOptionItem from "../models/FooterOptionItem";
import Routes from './../constants/Routes';
import {useSelector, RootStateOrAny} from "react-redux";
import {LoginState} from '../enums/AuthState';
import {Constants} from "../constants/Constants";

const footers = [
    {
        title: `${Strings.APP_NAME}`,
        description: [new FooterOptionItem('Multiply BTC', Routes.MULTIPLY_BTC), new FooterOptionItem('Win FREE BTC', Routes.FREE_BTC)],
    },
    {
        title: 'Resources',
        description: [new FooterOptionItem('Sign Up', Routes.SIGN_UP), new FooterOptionItem('Login', Routes.LOGIN), new FooterOptionItem('Bitcoin', Routes.BITCOIN), new FooterOptionItem('Bitcoin News', Routes.BITCOIN_NEWS)],
    },
    {
        title: 'Bitcoin',
        description: [new FooterOptionItem('Promotions', Routes.PROMOTIONS), new FooterOptionItem('Bitcoin Price', Routes.BITCOIN_PRICE), new FooterOptionItem('Bitcoin Wallet', Routes.BITCOIN_WALLET), new FooterOptionItem('Bitcoin Account', Routes.BITCOIN_ACCOUNT)],
    },
];

function Copyright() {

    const logInState: LoginState = useSelector((state: RootStateOrAny) => state.appReducer[Constants.LOGIN_STATE]);

    return (
        <Typography variant="body2" color="textSecondary" align="center" style={{
            marginBottom: 30,
            color: AppColors.GREY_TEXT
        }}>
            {'Copyright © '}
            <Link color="inherit" href={logInState === LoginState.STARTED ? "#" : "/"}>
                {Strings.APP_NAME}
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}

export default function OnBoardingFooterView() {
    const logInState: LoginState = useSelector((state: RootStateOrAny) => state.appReducer[Constants.LOGIN_STATE]);

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-evenly',
            flexWrap: 'wrap',
            backgroundColor: `${AppColors.PRIMARY_COLOR}`
        }}>
            <div style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-evenly',
                flexWrap: 'wrap',
                padding: 30,
            }}>
                <Typography style={{
                    color: 'white',
                    fontWeight: 600,
                    fontSize: 30,
                    alignSelf: 'center',
                    border: `6px solid ${red[600]}`,
                    padding: 10,
                    borderRadius: 100
                }}>18+</Typography>
                {footers.map((footer) => (
                    <div key={footer.title} style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        flexWrap: 'wrap',
                        alignItems: 'center'
                    }}>
                        <Typography variant="h6" style={{
                            color: grey[50]
                        }}>
                            {footer.title}
                        </Typography>
                        <ul>
                            {footer.description.map((item: FooterOptionItem) => (
                                <li key={item.title} style={{
                                    color: AppColors.GREY_TEXT,
                                    margin: 5,
                                }}>
                                    <ReactLink to={logInState === LoginState.STARTED ? "#" : item.link} style={{
                                        color: AppColors.GREY_TEXT,
                                        textDecoration: 'none',
                                    }}>
                                        {item.title}
                                    </ReactLink>
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>
            <Copyright/>
        </div>
    );
}